import { PhotoObject } from "@/object-cache";
import { useAppSelector } from "@/store/store-hooks";
import { selectIElementWorldTransform } from "@faro-lotv/app-component-toolbox";
import { JSX } from "react";

type FlyWalkPhotoRendererProps = {
  /** The current active Photo 2D */
  photo2D: PhotoObject | null;
};

/** @returns A component to render a PhotoObject in the correct pose. */
export function FlyWalkPhotoRenderer({
  photo2D,
}: FlyWalkPhotoRendererProps): JSX.Element | null {
  const globalPose = useAppSelector(
    selectIElementWorldTransform(photo2D?.iElement.id),
  );

  if (!photo2D) {
    return null;
  }

  return (
    <group {...globalPose}>
      <primitive object={photo2D} name={photo2D.iElement.id} />
    </group>
  );
}
